import React from 'react';
import { useTranslation } from 'react-i18next';

import { Input } from '@/primitives/Input';

import { ConfirmationDialog } from './ConfirmationDialog';

type FinaliseOrderDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (thirdPartyId: string) => void;
  thirdPartyId: string;
};

export const FinaliseOrderDialog = ({
  isOpen,
  onClose,
  onConfirm,
  thirdPartyId,
}: FinaliseOrderDialogProps) => {
  const { t } = useTranslation();
  const [internalThirdPartyId, setInternalThirdPartyId] =
    React.useState(thirdPartyId);

  const handleConfirm = () => {
    onConfirm(internalThirdPartyId);
  };

  return (
    <ConfirmationDialog
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={handleConfirm}
      title={t('agent.finaliseOrderDialog.title')}
      variant="primary"
    >
      <div
        style={{
          display: 'flex',
          gap: 'var(--space-xs)',
          alignItems: 'center',
          marginBottom: 'var(--space-m)',
        }}
      >
        <h3>{t('agent.orderCheckout.erpReference')}</h3>
        <Input
          className={'fullWidth'}
          type={'text'}
          value={internalThirdPartyId}
          onInput={(e) => {
            setInternalThirdPartyId(e.currentTarget.value);
          }}
        />
      </div>
      {t('agent.finaliseOrderDialog.content')}
    </ConfirmationDialog>
  );
};
